import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PeriodoModel } from '../models/periodo.model';
import { ApiVersion, ApiService } from 'src/app/services/api.service';

@Injectable()
export class PoaPeriodoService {
    constructor(private http: HttpClient, private apiService: ApiService) {}

    getPeriodos(): Observable<PeriodoModel[]> {
        return this.http.get<PeriodoModel[]>(
            `${this.apiService.getUrl()}/${ApiVersion}/periodos/`
        );
    }

    getAtivos(): Observable<PeriodoModel[]> {
      return this.http.get<PeriodoModel[]>(
          `${this.apiService.getUrl()}/${ApiVersion}/ativos/`
      );
  }


}
